// Vue
import { Component } from "vue-property-decorator";
// Template
import template from "./template.vue";
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { AufbauplusHeadline } from "#/components/aufbauplus_headline/AufbauplusHeadline";
import ModuleBase from "#/common/ModuleBase";
import { TypeA } from "./type_a/TypeA";
import { TypeB } from "./type_b/TypeB";
import { TypeC } from "./type_c/TypeC";

@Component({
  mixins: [template],
  components: {
    TypeA,
    TypeB,
    TypeC,
  },
})
export class TextBildModule extends ModuleBase {
  get typeComponent() {
    switch (this.instance["type"]) {
      case "type-a":
        return "TypeA";
      case "type-b":
        return "TypeB";
      case "type-c":
        return "TypeC";
      default:
        return null;
    }
  }

  getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }
}
